import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.LocFilter,
    dependencies: [
    ]
})
export class LocFilter {
    constructor() {
        return ((key: string, ...replacements: string[]) => {
            if (key) {
                // replacements = [replacement1, replacement2];
                let lkey = key.toLowerCase();
                let localizedString = loc[lkey];
                if (localizedString) {
                    let result = localizedString.format.apply(localizedString, replacements);
                    return result;
                }
            }
            return key;
        }) as any;
    }
}
